import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-dams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-dams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { ViewApplicationLocationDamsConstants } from "./view-application-location-dams.constants";
import { DemolitionManagementService } from "../../../../../shared/services/modules/demolition-management.service";
import { debounceTime } from "rxjs";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationLocationDamsComponent = class ViewApplicationLocationDamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    appController;
    routerParamsService;
    recipientListService;
    changeDetectorRefs;
    mapService;
    requestStatusService;
    viewApplicationService;
    modalService;
    demolitionManagementService;
    activeTabIndex;
    saveBtnPlaceholder = ViewApplicationLocationDamsConstants.SAVE_BUTTON_PLACEHOLDER;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationDamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationDamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationDamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationDamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationLocationDamsConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewApplicationLocationDamsConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationDamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationDamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationDamsConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationDamsConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationDamsConstants.ADDRESS_CONTROL;
    ownerControl = ViewApplicationLocationDamsConstants.OWNER_CONTROL;
    cadastralDescriptionControl = ViewApplicationLocationDamsConstants.CADASTRAL_DESCRIPTION_CONTROL;
    rateNumberControl = ViewApplicationLocationDamsConstants.RATE_NUMBER_CONTROL;
    existingUseControl = ViewApplicationLocationDamsConstants.EXISTING_USE_CONTROL;
    worthyOfPreservationControl = ViewApplicationLocationDamsConstants.WORTHY_OF_PRESERVATION_CONTROL;
    reasonControl = ViewApplicationLocationDamsConstants.REASON_CONTROL;
    over60Control = ViewApplicationLocationDamsConstants.OVER_60_CONTROL;
    amafaPermissionControl = ViewApplicationLocationDamsConstants.AMAFA_PERMISSION_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationDamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationDamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationDamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationDamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationDamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationDamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    cadastralDescriptionTextPlaceHolder = ViewApplicationLocationDamsConstants.CADASTRAL_DESCRIPTION_TEXT_PLACEHOLDER;
    rateNumberTextPlaceHolder = ViewApplicationLocationDamsConstants.RATE_NUMBER_TEXT_PLACEHOLDER;
    existingUseTextPlaceHolder = ViewApplicationLocationDamsConstants.EXISTING_USE_TEXT_PLACEHOLDER;
    worthyOfPreservationTextPlaceHolder = ViewApplicationLocationDamsConstants.WORTHY_OF_PRESERVATION_TEXT_PLACEHOLDER;
    reasonTextPlaceHolder = ViewApplicationLocationDamsConstants.REASON_TEXT_PLACEHOLDER;
    over60TextPlaceHolder = ViewApplicationLocationDamsConstants.OVER_60_TEXT_PLACEHOLDER;
    amafaPermissionTextPlaceHolder = ViewApplicationLocationDamsConstants.AMAFA_PERMISSION_TEXT_PLACEHOLDER;
    copyApplicantToOwnerLabel = ViewApplicationLocationDamsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    removePropertyLabel = ViewApplicationLocationDamsConstants.REMOVE_PROPERTY_LABEL;
    yesNoLookupOptions = LookupConstants.YES_NO;
    modalOptions = ViewApplicationLocationDamsConstants.MODAL_OPTION;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerLabel = "Owner";
    zones = [];
    mapComponent;
    application;
    isMapLoaded = false;
    missingOwnerErrMsg = ViewApplicationLocationDamsConstants.MISSING_OWNER_IN_PROPERTY;
    getApplicationSetPropertiesObservableSubscription;
    getStepMetaObservableSubscription;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    constructor(aflaModuleStrategyService, route, appController, routerParamsService, recipientListService, changeDetectorRefs, mapService, requestStatusService, viewApplicationService, modalService, demolitionManagementService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
        this.modalService = modalService;
        this.demolitionManagementService = demolitionManagementService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToProperty();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    onBtnSaveClicked() {
        if (this.propertiesForm.valid) {
            const points = [];
            const properties = [];
            let ownerMissingInProperty = false;
            const propertiesArray = this.getProperties();
            for (const item of propertiesArray.controls) {
                const centroid = item.get("centroid").value;
                points.push(`(${centroid.x} ${centroid.y})`);
                const geometry = item.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                const owners = item.get("owners").value.recipients;
                if (owners.length > 0) {
                    owners.forEach((owner) => {
                        RecipientUtils.removeRecipientProperties(owner);
                    });
                }
                else {
                    ownerMissingInProperty = true;
                    this.appController.showMessage(this.missingOwnerErrMsg, AlertType.Warning);
                    break;
                }
                const over60 = item.get("over60").value;
                const worthyOfPreservation = item.get("worthyOfPreservation").value;
                let amafaPermission = "";
                if (over60 === "Yes" || worthyOfPreservation === "Yes") {
                    amafaPermission = item.get("amafaPermission").value;
                }
                let property = null;
                if (item.get("property") !== null && item.get("property").value !== null) {
                    property = item.get("property").value;
                    property.address = item.get(this.addressControl).value;
                    property.allotment = item.get(this.allotmentControl).value;
                    property.erfNumber = item.get(this.erfNoControl).value;
                    property.farmNumber = item.get(this.farmNoControl).value;
                    property.sgCode = item.get(this.sgCodeControl).value;
                    property.subdivision = item.get(this.subdivisionControl).value;
                    property.owners = owners;
                    property.amafaPermission = amafaPermission;
                    property.cadastralDescription = item.get(this.cadastralDescriptionControl).value;
                    property.existingUse = item.get(this.existingUseControl).value;
                    property.over60 = over60;
                    property.rateNumber = item.get(this.rateNumberControl).value;
                    property.reason = item.get(this.reasonControl).value;
                    property.worthyOfPreservation = worthyOfPreservation;
                }
                else {
                    property = {
                        amafaPermission,
                        cadastralDescription: item.get(this.cadastralDescriptionControl).value,
                        existingUse: item.get(this.existingUseControl).value,
                        over60,
                        rateNumber: item.get(this.rateNumberControl).value,
                        reason: item.get(this.reasonControl).value,
                        worthyOfPreservation,
                        address: item.get(this.addressControl).value,
                        allotment: item.get(this.allotmentControl).value,
                        erfNumber: item.get(this.erfNoControl).value,
                        farmNumber: item.get(this.farmNoControl).value,
                        isDummy: false,
                        sgCode: item.get(this.sgCodeControl).value,
                        shape: geometryJSON,
                        subdivision: item.get(this.subdivisionControl).value,
                        updateGeometry: false,
                        wkid: 102100,
                        owners
                    };
                }
                properties.push(property);
            }
            if (!ownerMissingInProperty) {
                const params = {
                    properties,
                    applicationShape: `MULTIPOINT (${points.join(", ")})`,
                    applicationWkid: 102100
                };
                this.getApplicationSetPropertiesObservableSubscription =
                    this.demolitionManagementService.getApplicationSetPropertiesObservable(this.application.id, params)
                        .subscribe({
                        next: () => {
                            this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage(ViewApplicationLocationDamsConstants.STEP_TITLE, error, CRUDOperation.Update);
                        }
                    });
            }
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.application.applicant[0];
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.activeTabIndex = 0;
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.ownerGroups = stepMeta.ownerGroup;
            if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
            }
            this.getApplicantData();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `properties($expand=owners($expand=groups)),applicant($expand=groups)`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnValue) => {
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.application = returnValue.value[0];
            this.application.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newProperty = new FormGroup({
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber, [Validators.required]),
                    subdivision: new FormControl(property.subdivision, [Validators.required]),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    cadastralDescription: new FormControl(property.cadastralDescription, [Validators.required]),
                    rateNumber: new FormControl(property.rateNumber, [Validators.required]),
                    existingUse: new FormControl(property.existingUse, [Validators.required]),
                    worthyOfPreservation: new FormControl(property.worthyOfPreservation, [Validators.required]),
                    reason: new FormControl(property.reason, [Validators.required]),
                    over60: new FormControl(property.over60, [Validators.required]),
                    amafaPermission: new FormControl(property.amafaPermission),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    owners: new FormControl({ recipients: [] }, [Validators.required])
                });
                const ownersControl = newProperty.get("owners");
                this.recipientListService.setRecipients(property.owners, false, ownersControl);
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.viewApplicationService.getTrueCentroid(url, formData)
                    .pipe(takeUntil(this._destroy$), take(1))
                    .subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.activeTabIndex = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        this.updateRequiredFields(propertyControl.length - 1);
                        if (this.isMapLoaded) {
                            this.syncMapGeometries();
                        }
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationDamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(ViewApplicationLocationDamsConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                this.recipientListService.setRecipients(owners, false, ownersControl);
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.activeTabIndex = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                // this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.activeTabIndex = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Demolition management graphics", true);
        }
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Demolition management graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(ViewApplicationLocationDamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                cadastralDescription: new FormControl(null, [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null, [Validators.required]),
                rateNumber: new FormControl(null, [Validators.required]),
                existingUse: new FormControl(null, [Validators.required]),
                worthyOfPreservation: new FormControl(null, [Validators.required]),
                reason: new FormControl(null, [Validators.required]),
                over60: new FormControl(null, [Validators.required]),
                amafaPermission: new FormControl(null)
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.viewApplicationService.getTrueCentroid(url, formData)
                .subscribe({
                next: (response) => {
                    newProperty.get("centroid").setValue(response.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(ViewApplicationLocationDamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    checkAmafaStatus(selectedTabIndex) {
        const isWorthyOfPreservationValue = this.getProperties().controls[selectedTabIndex].get(this.worthyOfPreservationControl).value;
        const isOver60value = this.getProperties().controls[selectedTabIndex].get(this.over60Control).value;
        const amafaPermissionControl = this.getProperties().controls[selectedTabIndex].get(this.amafaPermissionControl);
        if (isWorthyOfPreservationValue?.toLowerCase() === "yes" || isOver60value?.toLowerCase() === "yes") {
            amafaPermissionControl.addValidators(Validators.required);
        }
        else {
            amafaPermissionControl.clearValidators();
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: RequestStatusService },
        { type: ViewApplicationService },
        { type: NgbModal },
        { type: DemolitionManagementService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationDamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-location-dams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationDamsComponent);
export { ViewApplicationLocationDamsComponent };
